// extracted by mini-css-extract-plugin
export default {"container":"Hot_container__lXsax","box":"Hot_box__Euns1"};